import { EstateRagDocumentSourceTypeKey } from '@/modules/ai/constants/EstateRagDocumentSourceTypeKey';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateRagSimilarityDataMetadataObject extends BaseEntityModel {
  id?: number;
  source?: EstateRagDocumentSourceTypeKey;
  chunkId?: string;
  documentId?: string;

  constructor(model: Partial<EstateRagSimilarityDataMetadataObject> = {}) {
    super(model);

    this.id = model.id;
    this.source = model.source;
    this.chunkId = model.chunkId;
    this.documentId = model.documentId;
  }
}
